
import Button from "@/Components/Buttons/Button.vue";
import ButtonGroup from "@/Components/Buttons/ButtonGroup.vue";
import Card from "@/Components/General/Card.vue";
import OrderList from "@/Components/Order/OrderList.vue";
import OrderListNav from "@/Components/Order/OrderListNav.vue";
import Changelogs from "@/Components/Product/Changelogs.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Order from "@/types/Order";
import Pagination from "@/types/Pagination";
import { Inertia } from "@inertiajs/inertia";
import { useForm } from "@inertiajs/inertia-vue3";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiPlus } from "@mdi/js";
import route from "ziggy-js";

import { PropType, computed, defineComponent, ref, watch } from "vue";
import { useStore } from "@/stores/main";
import Messages from "@/Components/General/Messages.vue";
import Multiselect from "@/Components/General/Multiselect.vue";

export default defineComponent({
  layout: AppLayout,
  props: {
    type: {
      type: String,
    },
    orders: {
      type: Object as PropType<Pagination<Order>>,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    status: {
      type: String,
    },
    shippingOptions: {
      type: Array,
    },
    shipping_type: {
      type: String,
    },
    product_type: {
      type: String,
    },
  },
  setup(props) {
    const store = useStore();
    store.setUpStore();

    const isAdmin = computed(() => store.isAdmin);
    const form = useForm({
      search: props.search ?? "",
      type: props.type ?? "orders",
      status: props.status ?? "open",
      shipping_type: props.shipping_type ?? "all",
      product_type: props.product_type ?? "all",
    });

    const productTypeOptions = computed(() => {
      return [
        { value: "all", label: "Alle" },
        { value: "product", label: "Produkter" },
        { value: "subscription", label: "Treningsabonnement" },
      ];
    });

    const statusOptions = computed(() => {
      const options = [
        {
          id: "open",
          title: "Åpne",
        },
        {
          id: "all",
          title: "Alle",
        },
      ];
      if (isAdmin.value && form.type !== "weborders") {
        options.push({
          id: "locked",
          title: "Låste ordre",
        });
      }

      if (form.type === "weborders") {
        options.push(
          {
            id: "cancelled",
            title: "Kansellerte",
          },
          {
            id: "unpaid",
            title: "Ubetalte",
          }
        );
      }

      return options;
    });

    const submit = () => {
      console.log({ form: form.data() });
      form.get(route(route().current() ?? ""));
    };

    watch(
      () => form.status,
      () => {
        submit();
      }
    );

    return {
      form,
      route,
      submit,
      mdiPlus,
      statusOptions,
      isAdmin,
      productTypeOptions,
    };
  },
  components: {
    Messages,
    Button,
    Card,
    Changelogs,
    OrderList,
    OrderListNav,
    ButtonGroup,
    SvgIcon,
    Multiselect,
  },
});
